import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

// Assuming the profile images (Profile pic.jpg) are imported like this:
import SpamTextsProfilePic from "./Avatars/PlainAvatar.jpg";

export const TimeSquareNYGirls: Chat_content[] = [
  {
    icon: SpamTextsProfilePic,
    name: "Ace_Y_769",
    messages: [
      {
        content: {
          type: "text",
          content:
            "Hey Shauna, you’re stunning. I need a date on Thursday night. I know a nice Italian place x",
        },
        timestamp: "2024-08-06T20:46:00Z",
        from: "Ace_Y_769",
      },
      {
        content: {
          type: "text",
          content:
            "Hi ace_Y_769, I’d love to be your date. Italian is my fave! I charge $1000 for a dinner date, and more if we go for drinks afterwards. Does that suit you? X",
        },
        timestamp: "2024-08-06T20:51:00Z",
        from: "Shauna",
      },
      {
        content: {
          type: "text",
          content:
            "Fantastic, I’ll pick you up from West 34th street, 6th Avenue. 8pm?",
        },
        timestamp: "2024-08-06T20:54:00Z",
        from: "Ace_Y_769",
      },
      {
        content: {
          type: "text",
          content:
            "Ok darling, I’ll be there. Which color would you like me to wear?",
        },
        timestamp: "2024-08-06T20:55:00Z",
        from: "Shauna",
      },
      {
        content: {
          type: "text",
          content: "I’d like to see you in red",
        },
        timestamp: "2024-08-06T20:57:00Z",
        from: "Ace_Y_769",
      },
      {
        content: {
          type: "text",
          content:
            "Red it is, baby. See you on Thursday evening. Can I have a contact number? X",
        },
        timestamp: "2024-08-06T20:59:00Z",
        from: "Shauna",
      },
      {
        content: {
          type: "text",
          content:
            "Call me on this number when you arrive at w 34 st, 6 av… +1 (625) 228 6182",
        },
        timestamp: "2024-08-06T21:03:00Z",
        from: "Ace_Y_769",
      },
    ],
    type: "individual",
    read: true,
  },
  {
    icon: SpamTextsProfilePic,
    name: "Ftz_1429",
    messages: [
      {
        content: {
          type: "text",
          content:
            "Hi Shauna, a friend of mine owns a spa & retreat upstate in Catskill. I want to take you there this weekend. What do you say?",
        },
        timestamp: "2024-07-15T12:36:00Z",
        from: "Ftz_1429",
      },
      {
        content: {
          type: "text",
          content:
            "Hi pumpkin, of course! That would be $3000. An extra $1000 if you want us to share a bed",
        },
        timestamp: "2024-07-15T13:48:00Z",
        from: "Shauna",
      },
      {
        content: {
          type: "text",
          content: "Great. I want the full service.",
        },
        timestamp: "2024-07-15T13:50:00Z",
        from: "Ftz_1429",
      },
      {
        content: {
          type: "text",
          content:
            "I’m all in, honey. Would you like to give me your name and contact number? X",
        },
        timestamp: "2024-07-15T13:52:00Z",
        from: "Shauna",
      },
      {
        content: {
          type: "text",
          content:
            "Yes, my number is +1 (312) 552 1778. Give me a call and we can arrange all the finer details. I’d rather tell you my name over the phone for privacy reasons.",
        },
        timestamp: "2024-07-15T13:56:00Z",
        from: "Ftz_1429",
      },
      {
        content: {
          type: "text",
          content:
            "No problem my sweet. I’ll give you a call this evening - are you around?",
        },
        timestamp: "2024-07-15T13:58:00Z",
        from: "Shauna",
      },
      {
        content: {
          type: "text",
          content: "Yes up until 8pm",
        },
        timestamp: "2024-07-15T13:59:00Z",
        from: "Ftz_1429",
      },
      {
        content: {
          type: "text",
          content: "Perfect honey x",
        },
        timestamp: "2024-07-15T14:00:00Z",
        from: "Shauna",
      },
    ],
    type: "individual",
    read: true,
  },
];
